import * as React from 'react';
import { useState } from "react";
import { EditComponent, CustomComponentProps } from 'src/components/common/Component';
import {
    useRecordContext,
    useRedirect
  } from "react-admin";
import { 
    Button, 
    Typography, 
    Box,
    Chip, 
    SpeedDialIcon, 
    Backdrop, 
    Menu,
    MenuItem,
    ListItemIcon,
    Divider
} from "@mui/material";
import { OrderStatusEnumIcons, OrderStatusEnumActions, OrderTypeEnum } from "src/common/enum";
import { ProcessingModal, ConfirmActionModal, ShipModal } from 'src/resources/sales/actions';

export function OrderShowComponent(props: CustomComponentProps) {
    const { children } = props;
    const record = useRecordContext();

    if (!record) return null;

    const OrderShowActions = (props) => {
        const { record } = props;
        let statusEnum = OrderStatusEnumIcons.find((status) => status.id === record.status);
        const [action, setAction] = useState(null);
        const [anchorActionsEl, setAnchorActionsEl] = React.useState<null | HTMLElement>(null);
        const openActions = Boolean(anchorActionsEl);
        const handleActionsClick = (event: React.MouseEvent<HTMLElement>) => {
            setAnchorActionsEl(event.currentTarget);
        };
        const handleActionsClose = () => {
            setAnchorActionsEl(null);
        };

        //Action Modals
        const [openProcessingModal, setOpenProcessingModal] = useState(false);
        const [openShipModal, setOpenShipModal] = useState(false);
        const [openConfirmActionModal, setOpenConfirmActionModal] = useState(false);

        const setOpenProcessingModalHandler = (value: boolean) => {
            if (!value) {
                setAction(null);
            }
            
            setOpenProcessingModal(value);
        }

        const setOpenShipModalHandler = (value: boolean) => {
            if (!value) {
                setAction(null);
            }
            
            setOpenShipModal(value);
        }

        const setOpenConfirmActionModalHandler = (value: boolean) => {
            if (!value) {
                setAction(null);
            }
            
            setOpenConfirmActionModal(value);
        }

        const executeAction = (action) => {
            setAction(action)

            if (action.id === 'processing') {
                setOpenProcessingModal(true);

                return;
            }
            
            if (action.id === 'ship') {
                setOpenShipModal(true);

                return;
            }

            setOpenConfirmActionModal(true);
        }

        return (
            <>
            <Box marginY="10px" display="flex" gap="5px">
                <Chip sx={{fontSize: "16px", padding: "8px 20px", height: "auto"}} label={statusEnum.name} color={statusEnum.color as any} icon={statusEnum.icon}/>
                <Box display="flex" gap="5px" sx={{marginLeft: "20px", alignItems: "center"}}>
                    <Backdrop sx={{ zIndex: "2"}} open={openActions} />
                    <Typography variant="subtitle1" color="primary" sx={{ marginRight: "10px"}} >Actions</Typography>

                    <Box onClick={handleActionsClick} sx={{
                        color: "#FFFFFF",
                        backgroundColor: "#1976d2",
                        cursor: "pointer",
                        height: "40px",
                        width: "40px",
                        borderRadius: "50%",
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "center",
                        zIndex: 10,
                    }}>
                        <SpeedDialIcon />
                    </Box>

                    <Menu
                        anchorEl={anchorActionsEl}
                        open={openActions}
                        onClose={handleActionsClose}
                        onClick={handleActionsClose}
                        PaperProps={{
                        elevation: 0,
                        sx: {
                            overflow: 'visible',
                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                            mt: 1.5,
                            '&:before': {
                                content: '""',
                                display: 'block',
                                position: 'absolute',
                                top: 0,
                                right: 14,
                                width: 10,
                                height: 10,
                                bgcolor: 'background.paper',
                                transform: 'translateY(-50%) rotate(45deg)',
                                zIndex: 0,
                            },
                        },
                        }}
                        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                    >
                        {OrderStatusEnumActions.filter((action) => { 
                            if (action.id === "ship-cfa") {
                                return record.cfa?.type === "requested" && action.statuses.includes(record.status);
                            }

                            if (action.hasOwnProperty('types')) {
                                return action.statuses.includes(record.status) && action.types.includes(record.type);
                            }

                            return action.statuses.includes(record.status);
                        }).map((action) => 
                            <MenuItem key={action.id} onClick={() => executeAction(action)}>
                                <Divider />
                                <ListItemIcon>
                                    {action.icon}
                                </ListItemIcon>
                                {action.name}
                            </MenuItem>
                        )}
                    </Menu>
                </Box>
            </Box>

            {openShipModal && action && 
            <ShipModal
                open={openShipModal}
                setOpen={setOpenShipModalHandler}
                record={record}
                action={action}
            />
            }

            {openProcessingModal && action && 
            <ProcessingModal
                open={openProcessingModal}
                setOpen={setOpenProcessingModalHandler}
                record={record}
                action={action}
            />
            }

            {openConfirmActionModal && action && 
            <ConfirmActionModal
                open={openConfirmActionModal}
                setOpen={setOpenConfirmActionModalHandler}
                record={record}
                action={action}
            />
            }

            </>
        );
    };

    const OrderTitle = (props) => {
        const { record } = props;
      
        return (
            <Box display="flex" gap="10px" sx={{alignItems: "center"}}>
                <Typography variant="subtitle1">{`Order #${record.increment_id}`}</Typography>
                <Typography variant="subtitle2">
                    <Chip
                        sx={{ marginLeft: "10px"}}
                        label={OrderTypeEnum.find((x) => x.id === record.type)?.name}
                    />
                </Typography>
            </Box>
        );
    };

    return (
        <EditComponent attributes={[]} title={<OrderTitle record={record}/>} actions={<OrderShowActions record={record}/>} children={children} />
    );
}